

export const countries = [
  {
    name: "Argentina",
    code: "+54",
    flag: "🇦🇷",
    format: "XXX-XXXX-XXXX",
    iso2: "AR"
  },
  {
    name: "Brasil",
    code: "+55",
    flag: "🇧🇷",
    format: "XXX-XXXX-XXXX",
    iso2: "BR"
  },
  {
    name: "Chile",
    code: "+56",
    flag: "🇨🇱",
    format: "XXX-XXXX-XXXX",
    iso2: "CL"
  },
  {
    name: "Colombia",
    code: "+57",
    flag: "🇨🇴",
    format: "XXX-XXXX-XXXX",
    iso2: "CO"
  },
  {
    name: "México",
    code: "+52",
    flag: "🇲🇽",
    format: "XXX-XXXX-XXXX",
    iso2: "MX"
  },
  {
    name: "Perú",
    code: "+51",
    flag: "🇵🇪",
    format: "XXX-XXXX-XXXX",
    iso2: "PE"
  },
  {
    name: "Uruguay",
    code: "+598",
    flag: "🇺🇾",
    format: "XXX-XXXX-XXXX",
    iso2: "UY"
  },
  {
    name: "Paraguay",
    code: "+595",
    flag: "🇵🇾",
    format: "XXX-XXXX-XXXX",
    iso2: "PY"
  },
  {
    name: "Ecuador",
    code: "+593",
    flag: "🇪🇨",
    format: "XXX-XXXX-XXXX",
    iso2: "EC"
  },
  {
    name: "Estados Unidos",
    code: "+1",
    flag: "🇺🇸",
    format: "XXX-XXX-XXXX",
    iso2: "US"
  },
  {
    name: "España",
    code: "+34",
    flag: "🇪🇸",
    format: "XXX-XXX-XXX",
    iso2: "ES"
  },
  {
    name: "Venezuela",
    code: "+58",
    flag: "🇻🇪",
    format: "XXX-XXXX-XXXX",
    iso2: "VE"
  }
];